var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddons = function SvgAddons(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 33H13C6.373 33 1 38.373 1 45s5.373 12 12 12h20.5v20.5c0 6.627 5.373 12 12 12s12-5.373 12-12V57H78c6.627 0 12-5.373 12-12s-5.373-12-12-12H57.5V12.5c0-6.627-5.373-12-12-12s-12 5.373-12 12V33z",
    fill: "#F7DAF3"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFB5E8",
    cx: 12,
    cy: 45,
    r: 12
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddons);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAiIGhlaWdodD0iOTAiIHZpZXdCb3g9IjAgMCA5MCA5MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zMy41IDMzSDEzQzYuMzczIDMzIDEgMzguMzczIDEgNDVzNS4zNzMgMTIgMTIgMTJoMjAuNXYyMC41YzAgNi42MjcgNS4zNzMgMTIgMTIgMTJzMTItNS4zNzMgMTItMTJWNTdINzhjNi42MjcgMCAxMi01LjM3MyAxMi0xMnMtNS4zNzMtMTItMTItMTJINTcuNVYxMi41YzAtNi42MjctNS4zNzMtMTItMTItMTJzLTEyIDUuMzczLTEyIDEyVjMzeiIgZmlsbD0iI0Y3REFGMyIvPjxjaXJjbGUgZmlsbD0iI0VGQjVFOCIgY3g9IjEyIiBjeT0iNDUiIHI9IjEyIi8+PC9nPjwvc3ZnPg==";